export class EmisorCFEDTO
{
  rut: string;
  razonSocial: string;
  domicilioFiscal: string;
  ciudad: string;
  departamento: string;
  esPeqContribuyente: boolean;
  esLiteralE: boolean;

  public limpiar(): void
  {
    this.rut = null;
    this.razonSocial = null;
    this.domicilioFiscal = null;
    this.ciudad = null;
    this.departamento = null;
    this.esPeqContribuyente = null;
    this.esLiteralE = null;
  }

  public copiarDatos(emisorCFEDTO: EmisorCFEDTO): void
  {
    this.rut = emisorCFEDTO.rut;
    this.razonSocial = emisorCFEDTO.razonSocial;
    this.domicilioFiscal = emisorCFEDTO.domicilioFiscal;
    this.ciudad = emisorCFEDTO.ciudad;
    this.departamento = emisorCFEDTO.departamento;
    this.esPeqContribuyente = emisorCFEDTO.esPeqContribuyente;
    this.esLiteralE = emisorCFEDTO.esLiteralE;
  }

  public toString(): string
  {
    const emisorCFEDTOStr: string = '(RUT: ' + this.rut + ', Razón social: ' + this.razonSocial + ', ' +
                                     'Domicilio fiscal: ' + this.domicilioFiscal + ', Ciudad: ' + this.ciudad + ', ' +
                                     'Departamento: ' + this.departamento + ')';

    return emisorCFEDTOStr;
  }
}
